import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import { useDeleteSupplier } from '../../hooks/useSuppliers';
import { useLanguage } from '../../lang/LangContext';
import { KEYS } from '../../lang/keys';

const DeleteSupplierModal = ({ isOpen, onClose, onSupplierDeleted, supplier }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const deleteSupplier = useDeleteSupplier();
  const { t } = useLanguage();

  const handleDelete = async () => {
    setDeleteError('');
    setIsDeleting(true);

    try {
      await deleteSupplier.mutateAsync(supplier.uid);
      if (onSupplierDeleted) onSupplierDeleted();
      onClose();
    } catch (error) {
      console.error('Error deleting supplier:', error);
      setDeleteError(error.message || t(KEYS.SUPPLIER_DELETE_ERROR));
    } finally {
      setIsDeleting(false);
    }
  };

  const handleClose = () => {
    if (!isDeleting) {
      setDeleteError('');
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t(KEYS.SUPPLIER_DELETE_TITLE)}
      subtitle={t(KEYS.SUPPLIER_DELETE_SUBTITLE)}
      size="small"
      footer={
        <>
          <Button
            variant="outline"
            onClick={handleClose}
            disabled={isDeleting}
          >
            {t(KEYS.COMMON_CANCEL)}
          </Button>
          <Button
            variant="danger"
            onClick={handleDelete}
            disabled={isDeleting}
          >
            {isDeleting ? t(KEYS.SUPPLIER_DELETE_SUBMITTING) : t(KEYS.COMMON_DELETE)}
          </Button>
        </>
      }
    >
      {deleteError && (
        <div className="p-3 mb-4 bg-status-overdue-bg text-status-overdue rounded text-sm">
          {deleteError}
        </div>
      )}
      
      <div className="py-2 space-y-3">
        <div className="flex items-start gap-3 p-3 bg-status-overdue-bg rounded border border-status-overdue/20">
          <AlertTriangle className="w-5 h-5 text-status-overdue flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-text-primary font-medium">
              Delete <strong>{supplier?.name}</strong>?
            </p>
            <p className="text-sm text-text-secondary mt-1">
              {t(KEYS.SUPPLIER_DELETE_BODY)}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSupplierModal;
